export const useAdjustHoursReportColumns = () => {
  return [
    {
      headerName: 'Employee',
      field: 'employee',
    },
    {
      headerName: 'Reason',
      field: 'reason',
    },
    {
      headerName: 'Hours',
      field: 'hours',
    },
  ];
};

export default useAdjustHoursReportColumns;
